/* eslint-disable */
import { FaMobileAlt } from "react-icons/fa";
import { MdWeb } from "react-icons/md";
import LanguageIcon from '@material-ui/icons/Language';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import BuildIcon from '@material-ui/icons/Build';

export const servicesData = [
    {
        id: 1,
        title: 'Web Application Development',
        icon: <MdWeb />
    },
    {
        id: 2,
        title: 'Website Development',
        icon: <LanguageIcon />
    },
    {
        id: 3,
        title: 'Mobile App Development',
        icon: <FaMobileAlt />
    },

    {
        id: 4,
        title: 'Testing & Quality Assurance',
        icon: <PlaylistAddCheckIcon />
    },

    {
        id: 5,
        title: 'Maintenance & Support',
        icon: <BuildIcon />
    },
    // {
    //     id: 6,
    //     title: 'API Development',
    //     icon: <AiOutlineApi />
    // },

]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.